import { css } from '@emotion/react'
import { Color, Spacing, Theme, Typography } from '@opallabs/gem'

/**
 * Where the value's text starts: the input's padding plus its border. The
 * label and the divider line up with it, so the field reads as one column and
 * only the box around an editable value reaches past it.
 */
const VALUE_INSET = Spacing.S + 1

export const fieldWrapper = (theme: Theme, disabled?: boolean) =>
  css({
    paddingBlockStart: Spacing.L,
    width: '100%',
    opacity: disabled ? 0.5 : 1,
    pointerEvents: disabled ? 'none' : 'auto',
    transition: 'opacity 0.3s ease-in-out',

    // Drawn as a child rather than a border, so it can stop short of the edges.
    '&::after': {
      backgroundColor: Color[theme]['Strokes/Secondary-1'],
      blockSize: 1,
      content: '""',
      display: 'block',
      marginBlockStart: Spacing.M,
      marginInline: VALUE_INSET,
    },
  })

export const labelStyles = css({
  columnGap: Spacing.XS,
  display: 'inline-flex',
  marginBottom: Spacing.S,
  paddingInlineStart: VALUE_INSET,
  ...Typography.H50,
})
